import React from 'react'

export const BoxFooter = React.forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>((props, ref) => {
  const { className, ...rest } = props
  return <div ref={ref} className={`flex px-8 pb-5 pt-7 space-x-4 ${className}`} {...rest}>
    {props.children}
  </div>
})